<template>
  <div class="group">
    <span class="flex items-center px-4 py-2 hover:bg-gray-300 cursor-pointer" @click="(event) => $emit('click', event)">
      <slot name="icon" />
      <span class="flex-grow"><slot name="label" /></span>
      <AtomIconChevronRight v-show="hasFoldout" class="mr-3 h-4 w-4 shrink-0" />
    </span>

    <div
      v-show="hasFoldout"
      class="v-foldout invisible absolute left-80 top-1 z-50 w-max overflow-scroll border-2 border-solid border-gray-300 bg-white drop-shadow group-hover:visible"
    >
      <slot name="foldout" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  hasFoldout: { type: Boolean, required: false, default: true },
})

defineEmits(['click'])
</script>

<style scoped>
.v-foldout {
  max-height: 90vh;
}
</style>
